export default [
    {
      id: "1",
      score: "4000",
      created_at: "۱۸:۴۱:۴۴ ۱۴۰۱/۰۶/۲۸",
    },
    {
      id: "2",
      score: "5000",
      created_at: "۱۸:۵۱:۴۴ ۱۴۰۱/۰۶/۲۸",
    },
    {
      id: "3",
      score: "2000",
      created_at: "۱۹:۰۱:۴۴ ۱۴۰۱/۰۶/۲۸",
    },
    {
      id: "4",
      score: "6000",
      created_at: "۱۹:۱۱:۴۴ ۱۴۰۱/۰۶/۲۸",
    },
    {
      id: "5",
      score: "7000",
      created_at: "۱۹:۲۱:۴۴ ۱۴۰۱/۰۶/۲۸",
    },
    {
      id: "6",
      score: "3400",
      created_at: "۱۹:۳۱:۴۴ ۱۴۰۱/۰۶/۲۸",
    },
  ];
  